<div id="wrapper">
  <div id="content">

    <!-- 📄 Left Column: Title and Bio text -->
    <div class="text-column">
      <app-text-effect [input]="'Android Developer'"></app-text-effect>
      <br><br>

      <!-- Content Sub-wrapper -->
      <div class="bio-subtitles">
        <p>
          My name is <b>Jakub Wegielewski</b>
          <br><br>
          I design and implement custom applications, solving real-world problems step by step.
        </p>

        <!-- Target portfolio text with a unique identifier class -->
        <h3 class="portfolio-cta">
          Take a look at my extensive <a routerLink="/portfolio">portfolio</a>.
        </h3>
      </div>
    </div>

    <!-- 🖼️ Right Column: Image Block -->
    <div class="tooltip image-container">
      <img alt="Hello" src="../../../assets/images/me.png" title="Hello" width="256" height="256"
           class="circle-img">
      <span class="tooltip-text">Hello</span>
    </div>

  </div>
</div>
